import type { IDebugLabel } from '../IRenderer';

/**
 * createDebugLabel — substrate-agnostic factory for diagnostic-overlay text.
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserDebugLabel fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot.
 */

type PixiFactory = () => IDebugLabel;

let pixiFactory: PixiFactory | null = null;

export function registerPixiDebugLabelFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function createDebugLabel(_scene: unknown): IDebugLabel {
  if (!pixiFactory) {
    throw new Error('[createDebugLabel] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory();
}
